/**
 * 7 публичных текстовых маршрутов (TZ §12). Каждый - тонкий wrapper
 * вокруг StaticPage с готовым контентом из staticContent.ts. Если потом
 * захотим вынести контент в БД - заменить импорт на useQuery.
 */
import { StaticPage } from "./StaticPage";
import {
  FAQ_CONTENT, HELP_CONTENT, CONTACTS_CONTENT, TERMS_CONTENT,
  PRIVACY_CONTENT, REFUNDS_CONTENT, CREDITS_POLICY_CONTENT,
} from "./staticContent";

export const FaqPage           = () => <StaticPage {...FAQ_CONTENT} />;
export const HelpPage          = () => <StaticPage {...HELP_CONTENT} />;
export const ContactsPage      = () => <StaticPage {...CONTACTS_CONTENT} />;
export const TermsPage         = () => <StaticPage {...TERMS_CONTENT} />;
export const PrivacyPage       = () => <StaticPage {...PRIVACY_CONTENT} />;
export const RefundsPage       = () => <StaticPage {...REFUNDS_CONTENT} />;
export const CreditsPolicyPage = () => <StaticPage {...CREDITS_POLICY_CONTENT} />;
